import React from "react";

const MDF = ({
  width = 20,
  height = 21,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 4.5V4H12.25H4.75H4.25V4.5V16.5V17H4.75H15.25H15.75V16.5V7.5V7H15.25H12.75V4.5ZM16.75 6.75V17.2448L3.25 3.744C3.25 3.333 3.58525 3 3.99925 3H13L16.75 6.75ZM3.75 17.2535V3.744C3.75 3.61241 3.85812 3.5 3.99925 3.5H12.7929L16.25 6.95711L16.25 17.2448L16.25 17.2483C16.2502 17.2811 16.244 17.3137 16.2317 17.3441L16.6949 17.5322L16.2317 17.3441C16.2193 17.3745 16.2011 17.4022 16.178 17.4256C16.155 17.4489 16.1275 17.4675 16.0973 17.4803C16.0675 17.4929 16.0354 17.4996 16.0031 17.5H3.99694C3.93175 17.4992 3.86943 17.473 3.82329 17.4269C3.77718 17.3808 3.7509 17.3186 3.75 17.2535ZM9.75 10.25H10.25V13.75H9.75V10.25ZM9.75 7.25H10.25V7.75H9.75V7.25Z"
        stroke="#868C98"
      />
    </svg>
  );
};

export default MDF;
